<!-- 選擇產品群組項目 -->
<ng-template #Modal let-data let-ref="dialogRef"  >
    <nb-card class="staffInfoTemplate mo1"  [nbSpinner]="info.IsLoding">
      <nb-card-header>
        選擇附加品項分類
      </nb-card-header>
      <nb-card-body>
  
        <div class="row mx-0 mt-3">
          <input  class="col"  [(ngModel)]="query.searchKey" name="searchKey" type="text" nbInput fullWidth 
            shape="rectangle" placeholder="輸入附加品項分類名稱">           
          <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
            <i class="fas fa-search"></i>
          </button>            
        </div>

        <div class="d-flex mx-0 mt-2 justify-content-between">         
          <nb-select class="col-auto pr-0 ml-auto"   style="width:180px" 
              [(ngModel)]="selectORG_Store_ID" (selectedChange)="onQuery()">
              <nb-option *ngFor="let e of storeSelectList" [value]="e.value" > {{ e.content }}</nb-option>
          </nb-select>         
        </div>



        <div class="mt-3"> 
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>分類名稱</th>
                <th>選擇</th>
                <th>建立門市</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let e of mainDataList ">
                <tr>
                  <td> {{ e.GroupName }}</td>
                  <td >{{e.CreateStoreName}}</td>
                  <td>
                    <nb-toggle status="info" [(checked)]="e.IsOK_Group" 
                      (checkedChange)="onSelectG(e)">
                    </nb-toggle>
                  </td>
                  
                  <td>
                 
                    <button nbButton class="m-0  col-sm-12"   
                      (click)="onOpenPd(e)">   
                        {{ e.CountStr ? e.CountStr : '選擇'}}</button>  
                </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSavePdG();">確定</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>
  
  
  <!-- 選擇產品 -->
  <ng-template #PdModal let-data let-ref="dialogRef">
    <nb-card class="staffInfoTemplate mo2">
      <nb-card-header>
        選擇附加品項群組
      </nb-card-header>
      <nb-card-body>
  
        <div class="mt-3">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                
                <th>建立門市</th>
                <th>附加品項群組標題</th>
                <th>選項內容</th>
                <th>選項類型</th>
                <th>必選</th>
                <th>選擇</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of showListPd">
                <tr>
                  
                   <td >{{item.CreateStoreName}}</td>
                    <td >{{item.GroupName}}</td>
                    <td >{{item.Content}}</td>
                    <td >{{item.AttachItemKindName}}</td>
                    <td >{{item.IsRequiredName}}</td>
                  <td>
                    <nb-toggle status="info" class="" [(checked)]="item.IsOK_Product"
                      (checkedChange)="insertData(item,item.IsOK_Product)" >
                    </nb-toggle>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSavePd();">確定</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>



    